import { useRef, useEffect, useCallback } from 'react';

/**
 * Get whether a component has mounted.
 * @returns boolean
 */
var useMounted = function useMounted() {
  var isMounted = useRef(false);
  useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  return useCallback(function () {
    return isMounted.current;
  }, [])();
};
export { useMounted };